<wl-experience-editor>
  <ng-template wlLive>
    @if (route$ | async; as route) {
      <article class="row py-3 py-md-4" [ngClass]="rowSpacing">
        <div class="d-none d-lg-block col col-lg-3">
          <div
            sc-placeholder
            name="column-left"
            class="content-item"
            [ngClass]="contentOptionsLeft"
            [rendering]="rendering"
          ></div>
        </div>
        <div class="col col-xs-12 col-lg-9">
          @if (route.isLoading) {
            <div class="content-item" [ngClass]="contentOptionsCenter">
              <wl-skeleton-loading-card></wl-skeleton-loading-card>
            </div>
          } @else {
            <div
              sc-placeholder
              name="column-center"
              class="content-item"
              [ngClass]="contentOptionsCenter"
              clientOnly="true"
              [rendering]="rendering"
            >
              <wl-skeleton-loading-card
                *scPlaceholderLoading
              ></wl-skeleton-loading-card>
            </div>
          }
        </div>
      </article>
    }
  </ng-template>
  <ng-template wlPreview>
    <article class="row my-3 my-md-4" [ngClass]="rowSpacing">
      <div class="d-none d-lg-block col col-lg-3">
        <div
          sc-placeholder
          name="column-left"
          class="content-item"
          [ngClass]="contentOptionsLeft"
          [rendering]="rendering"
        ></div>
      </div>
      <div class="col col-xs-12 col-lg-9">
        <div
          sc-placeholder
          name="column-center"
          class="content-item"
          [ngClass]="contentOptionsCenter"
          [rendering]="rendering"
        ></div>
      </div>
    </article>
  </ng-template>
</wl-experience-editor>
